import React, { useEffect } from 'react';
import { useNotesStore } from '../store';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Trash2, RotateCcw, X } from 'lucide-react';

export default function TrashView() {
  const { trashNotes, fetchTrash, restoreFromTrash, permanentDelete, emptyTrash } = useNotesStore();

  useEffect(() => { fetchTrash(); }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold flex items-center gap-2"><Trash2 size={20} /> Trash</h1>
          <p className="text-sm text-muted-foreground">{trashNotes.length} deleted notes</p>
        </div>
        {trashNotes.length > 0 && (
          <Button variant="destructive" size="sm" onClick={() => { if (confirm('Empty trash?')) emptyTrash(); }}>
            Empty Trash
          </Button>
        )}
      </div>

      {trashNotes.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          <Trash2 size={48} className="mx-auto mb-4 opacity-50" />
          <p>Trash is empty</p>
        </div>
      ) : (
        <div className="space-y-2">
          {trashNotes.map(note => (
            <Card key={note.id}>
              <CardContent className="flex items-center justify-between p-4">
                <div>
                  <h3 className="font-medium">{note.title}</h3>
                  <p className="text-xs text-muted-foreground">
                    Deleted {new Date(note.deleted_at).toLocaleDateString()}
                  </p>
                </div>
                <div className="flex gap-2">
                  <Button variant="ghost" size="sm" onClick={() => restoreFromTrash(note.id)}>
                    <RotateCcw size={14} className="mr-1" /> Restore
                  </Button>
                  <Button variant="ghost" size="sm" className="text-destructive" onClick={() => { if (confirm('Permanently delete?')) permanentDelete(note.id); }}>
                    <X size={14} className="mr-1" /> Delete
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
